// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart-container {
  display: grid;
  font-family: var(--font-stack-full-regular);
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr;
  grid-auto-columns: 1fr;
  gap: 32px;
  grid-auto-flow: row;
  color: var(--grey-color-90);
  grid-template-areas: "left-info chart right-info";
}

.left-info {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr;
  grid-auto-flow: row;
  grid-area: left-info;
}

.l-top-area {
  align-self: start;
  justify-self: end;
  justify-items: end;
}

.l-bot-area {
  align-self: end;
  justify-self: end;
  justify-items: end;
}

.right-info {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr;
  grid-auto-flow: row;
  grid-template-areas: "r-top-area" "r-bot-area";
  grid-area: right-info;
}

.r-top-area {
  grid-area: r-top-area;
  align-self: start;
  justify-self: start;
  justify-items: start;
}

.r-bot-area {
  grid-area: r-bot-area;
  align-self: end;
  justify-self: start;
  justify-items: start;
}

.area-text {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-weight: 500;
  font-size: 20px;
}

.area-percentage {
  display: flex;
  align-items: baseline;
  gap: 8px;
  font-weight: 500;
  font-size: 40px;
}

.polar-wrapper {
  position: relative;
  height: 430px;
  width: 430px;
  grid-area: chart;
}

.center-circle {
  border: 1px solid var(--grey-color-300);
  height: 50%;
  width: 50%;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
}

.center-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.text-center {
  text-align: center;
  white-space: pre;
  align-items: flex-end !important;
  font-weight: 500;
  font-size: 20px;
}

.action-status {
  border-radius: 50%;
  height: 14px;
  width: 14px;
}

.pill-score {
  padding: 4px 8px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 500;
}

.action-arrow {
  padding: 8px;
  font-size: 30px !important;
  background: var(--grey-color-10);
  color: var(--grey-color-70);
  border-radius: 50%;
  cursor: pointer;
}

.tooltipStyle {
  white-space: normal;
}`, "",{"version":3,"sources":["webpack://./src/components/HeidrickScoreChart/HeidrickScoreChart.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,2CAAA;EACA,kCAAA;EACA,uBAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,2BAAA;EACA,iDAAA;AACF;;AAEA;EACE,aAAA;EACA,0BAAA;EACA,2BAAA;EACA,mBAAA;EACA,oBAAA;AACF;;AAEA;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,0BAAA;EACA,2BAAA;EACA,mBAAA;EACA,8CACE;EAEF,qBAAA;AADF;;AAIA;EACE,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;AADF;;AAIA;EACE,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AADF;;AAIA;EACE,aAAA;EACA,qBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;AADF;;AAIA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;AADF;;AAIA;EACE,uCAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,uBAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AADF;;AAIA;EACE,kBAAA;EACA,gBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;AADF;;AAIA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AADF;;AAIA;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AADF;;AAIA;EACE,YAAA;EACA,0BAAA;EACA,gCAAA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;AADF;;AAIA;EACE,mBAAA;AADF","sourcesContent":[".chart-container {\n  display: grid;\n  font-family: var(--font-stack-full-regular);\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-template-rows: 1fr;\n  grid-auto-columns: 1fr;\n  gap: 32px;\n  grid-auto-flow: row;\n  color: var(--grey-color-90);\n  grid-template-areas: \"left-info chart right-info\";\n}\n\n.left-info {\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr 1fr;\n  grid-auto-flow: row;\n  grid-area: left-info;\n}\n\n.l-top-area {\n  align-self: start;\n  justify-self: end;\n  justify-items: end;\n}\n\n.l-bot-area {\n  align-self: end;\n  justify-self: end;\n  justify-items: end;\n}\n\n.right-info {\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr 1fr;\n  grid-auto-flow: row;\n  grid-template-areas:\n    \"r-top-area\"\n    \"r-bot-area\";\n  grid-area: right-info;\n}\n\n.r-top-area {\n  grid-area: r-top-area;\n  align-self: start;\n  justify-self: start;\n  justify-items: start;\n}\n\n.r-bot-area {\n  grid-area: r-bot-area;\n  align-self: end;\n  justify-self: start;\n  justify-items: start;\n}\n\n.area-text {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n  font-weight: 500;\n  font-size: 20px;\n}\n\n.area-percentage {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  font-weight: 500;\n  font-size: 40px;\n}\n\n.polar-wrapper {\n  position: relative;\n  height: 430px;\n  width: 430px;\n  grid-area: chart;\n}\n\n.center-circle {\n  border: 1px solid var(--grey-color-300);\n  height: 50%;\n  width: 50%;\n  border-radius: 50%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: white;\n}\n\n.center-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.text-center {\n  text-align: center;\n  white-space: pre;\n  align-items: flex-end !important;\n  font-weight: 500;\n  font-size: 20px;\n}\n\n.action-status {\n  border-radius: 50%;\n  height: 14px;\n  width: 14px;\n}\n\n.pill-score {\n  padding: 4px 8px;\n  border-radius: 10px;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.action-arrow {\n  padding: 8px;\n  font-size: 30px !important;\n  background: var(--grey-color-10);\n  color: var(--grey-color-70);\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n.tooltipStyle {\n  white-space: normal;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
